/**
 * Duffel payment_requirements → FE bookingMode helpers.
 * Values come only from resolve (never invented).
 */

/**
 * @typedef {object} HrPaymentRequirements
 * @property {boolean} requiresInstantPayment
 * @property {string|null} paymentRequiredBy
 * @property {string|null} priceGuaranteeExpiresAt
 */

/**
 * @param {unknown} raw
 * @returns {HrPaymentRequirements|null}
 */
export function normalizePaymentRequirements(raw) {
  if (!raw || typeof raw !== "object") return null;
  const requires = raw.requiresInstantPayment;
  if (typeof requires !== "boolean") return null;
  const payBy = raw.paymentRequiredBy;
  const guarantee = raw.priceGuaranteeExpiresAt;
  return {
    requiresInstantPayment: requires,
    paymentRequiredBy:
      payBy != null && String(payBy).trim() !== "" ? String(payBy).trim() : null,
    priceGuaranteeExpiresAt:
      guarantee != null && String(guarantee).trim() !== ""
        ? String(guarantee).trim()
        : null,
  };
}

/**
 * @param {HrPaymentRequirements|null|undefined} pr
 * @returns {"instant"|"hold-eligible"|null}
 */
export function deriveBookingMode(pr) {
  if (!pr || typeof pr.requiresInstantPayment !== "boolean") return null;
  return pr.requiresInstantPayment === false ? "hold-eligible" : "instant";
}

/**
 * Read paymentRequirements from resolve payload or selected offer.
 * @param {object|null|undefined} offerOrResolve
 * @returns {HrPaymentRequirements|null}
 */
export function getPaymentRequirements(offerOrResolve) {
  if (!offerOrResolve || typeof offerOrResolve !== "object") return null;
  return (
    normalizePaymentRequirements(offerOrResolve.paymentRequirements) ||
    normalizePaymentRequirements(offerOrResolve.resolveMeta?.paymentRequirements) ||
    null
  );
}

/**
 * Format ISO datetime for Hebrew agent UI (date + time, local).
 * @param {string|null|undefined} iso
 * @returns {string|null}
 */
export function formatPaymentDeadlineHe(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  try {
    return new Intl.DateTimeFormat("he-IL", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(d);
  } catch {
    return String(iso);
  }
}
